"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BuildArea = _interopRequireDefault(require("./BuildArea.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BuildArea = function BuildArea(_ref) {
  var children = _ref.children,
    className = _ref.className,
    hasError = _ref.hasError,
    isEmpty = _ref.isEmpty,
    fillBackground = _ref.fillBackground;
  return /*#__PURE__*/_react["default"].createElement(_BuildArea["default"], {
    hasError: hasError,
    isEmpty: isEmpty,
    className: className,
    fillBackground: fillBackground
  }, children);
};
BuildArea.defaultProps = {
  hasError: false,
  isEmpty: true,
  className: 'building-area',
  fillBackground: false
};
BuildArea.propTypes = {
  /** Text or html to be displayed inside the card */
  children: _propTypes["default"].node.isRequired,
  /** Flag to indicare weather the placeholder should be marked as error or not */
  hasError: _propTypes["default"].bool,
  /** Flag to indicate that the build area should render a placeholder */
  isEmpty: _propTypes["default"].bool,
  /** A class name  */
  className: _propTypes["default"].string,
  /** Flag to indicate that the build area should have a background color set */
  fillBackground: _propTypes["default"].bool
};
BuildArea.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BuildArea",
  "props": {
    "hasError": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicare weather the placeholder should be marked as error or not",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isEmpty": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Flag to indicate that the build area should render a placeholder",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'building-area'",
        "computed": false
      },
      "description": "A class name",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "fillBackground": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate that the build area should have a background color set",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "description": "Text or html to be displayed inside the card",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = BuildArea;
exports["default"] = _default;